export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "customers",
      layout: "dashboard",
    },
    path: "/customers",
    name: "customers",
    component: () => import("@/layouts/index/CustomersIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste de clients",
          layout: "dashboard",
        },
        path: "index",
        name: "customers-index",
        component: () => import("@/views/customers/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un compte clientèle",
          layout: "dashboard",
        },
        path: "create",
        name: "customers-create",
        component: () => import("@/views/customers/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier le compte clientèle",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "customers-edit",
        component: () => import("@/views/customers/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Details de compte clientèle",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "customers-details",
        component: () => import("@/views/customers/Details.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Nature des comptes clients",
          layout: "dashboard",
        },
        path: "types/index",
        name: "customers-types-index",
        component: () => import("@/views/customer_types/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un type de compte clientèle",
          layout: "dashboard",
        },
        path: "types/create",
        name: "customers-types-create",
        component: () => import("@/views/customer_types/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Vendeurs",
          layout: "dashboard",
        },
        path: "sellers/index",
        name: "customers-sellers-index",
        component: () => import("@/views/customers/Sellers.vue"),
      },
    ],
  },
];
